import React from 'react'
import DpTagTheme from '@/libs/components/DpUiComponents/DpTagTheme'
export const FormTags = (props: any) => {
  const tags = props?.value && (typeof props?.value === 'string' ? props?.value?.split?.(',') : props?.value)
  if (!tags || !tags?.length) return <span></span>
  return tags?.map((item: string) => <DpTagTheme key={item} style={{ marginLeft: 4, display: 'inline-block' }}>{item}</DpTagTheme>)
}
